import React from 'react';
import { connect } from 'react-redux';
import { actions, signinActions } from '../../actions';
import { LanguagesMenu as LanguagesMenuView } from '../design/topBar/LanguagesMenu';
import * as socialControlsActions from "../../actions/socialControlsActions";

class LanguagesMenu extends React.Component {
  onChangeSelectedLanguageClick = (event, lang) => {
    event.preventDefault();
    this.props.changeSelectedLanguage(lang);
    window.location.href = this.props.localizedUrls[lang];
  };

  render = () => <LanguagesMenuView onChangeClick={this.onChangeSelectedLanguageClick} { ...this.props } />
}

const mapState = state => ({
  opened: state.signin.languageMenuOpened,
  languageSelected: state.signin.languageSelected,
  localizedUrls: window.localizedUrls
});


const mapDispatch = (dispatch, ownProps) => ({
  changeSelectedLanguage: (lang) => {
    dispatch(signinActions.setSelectedLanguage(lang));
    dispatch(signinActions.closeLanguageMenu());
  },
  onToggleClick: () => {
    dispatch(signinActions.toggleLanguageMenu());
    dispatch(actions.episodesControlsSetClosed());
    dispatch(socialControlsActions.closeDrawer());
    dispatch(socialControlsActions.closeSocialDropdown());
    dispatch(signinActions.closeModal());
    dispatch(signinActions.closeUserMenu());
  }
});

export default connect(mapState, mapDispatch)(LanguagesMenu);
